import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el material después de pagar?',
  a: 'Inmediatamente después de completar el pago recibís un email con el link de acceso a todos los archivos. El acceso es de por vida.'
}, {
  q: '¿En qué formato están los materiales?',
  a: 'Todos los archivos son PDF de alta calidad, listos para leer en computadora, tablet o celular. También podés imprimirlos.'
}, {
  q: '¿Sirve si recién estoy empezando?',
  a: 'Sí. El Megapack fue diseñado tanto para esteticistas que están arrancando como para las que ya tienen experiencia y quieren sistematizar su trabajo.'
}, {
  q: '¿Puedo pagar en cuotas?',
  a: 'Sí, podés pagar con tarjeta de crédito en cuotas a través de MercadoPago al momento del checkout.'
}, {
  q: '¿Qué diferencia hay entre el Megapack y la Edición Avanzada?',
  a: "El Megapack incluye todo el sistema base: 6 guías + 6 herramientas. La Edición Avanzada agrega el material 'De Consultorio a Marca', enfocado en especialización, autoridad digital y escalado del negocio."
}];
export function FAQSection() {
  return <section className="py-24 px-6 bg-brand-white" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-brand-purple mb-16 text-center" data-id="element-56">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-6" data-id="element-57">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-brand-cream/30 rounded-2xl p-6 md:p-8 border border-brand-cream" data-id="element-58">
              <h4 className="text-xl font-bold text-brand-purple font-sans mb-3" data-id="element-59">
                {faq.q}
              </h4>
              <p className="text-gray-700 font-sans leading-relaxed" data-id="element-60">{faq.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}